import {FormatAddressProps} from 'presentation/constants';
import {formatMasks} from './formatMasks';
import {formatText} from './formatText';
import {getCityAndUfByRegex} from './getCityAndUfByRegex';

const removeNumberIfDuplicated = (address: string, number: string) => {
	if (number.length > 0 && number !== '0') {
		const escapedNumber = number.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
		return address.replace(new RegExp(`(?:,\\s*${escapedNumber}|\\s${escapedNumber})$`), '');
	}
	return address;
};

const removeTypeIfDuplicated = (address: string) =>
	address.replace(/(AV|R)(?=\s\1\b|\s\1\b)/gi, '');

const formatAddress = (data?: FormatAddressProps | string): string => {
	if (!data) {
		return '';
	}
	if (typeof data === 'string') return data;

	const {type, address, number, district, city, state, complement, reference, zipCode} = data;

	const addressData = {
		type: type ?? '',
		address: address ? removeTypeIfDuplicated(address) : '',
		number: number ?? '',
		complement: complement === 'SEM COMPLEMENTO' ? '' : (complement ?? ''),
		reference: reference ?? '',
		district: district ?? '',
		city: city ?? '',
		state: state ?? '',
		zipCode: zipCode ? formatMasks('cep', zipCode) : '',
	};

	const stateSuffix = addressData.state ? `/${addressData.state}` : '';

	function formatAdressWithDistrict() {
		if (addressData.district) {
			return `${addressData.district} - ${addressData.city}${stateSuffix}`;
		}
		return `${addressData.city}${stateSuffix}`;
	}

	const addressWithoutNumber = removeNumberIfDuplicated(addressData.address, addressData.number);

	const numberPart =
		addressData.number && addressData.number !== '0' ? `, ${addressData.number}` : '';
	const complementPart = addressData.complement ? `- ${addressData.complement}` : '';
	const referencePart = addressData.reference ? `- ${addressData.reference}` : '';
	const districtPart = addressData.district ? `- ${addressData.district}` : '';

	const completeAddress = !addressData.address
		? formatAdressWithDistrict()
		: `${addressData.type} ${addressWithoutNumber}${numberPart}${complementPart}${referencePart}${districtPart} - ${addressData.city}${stateSuffix} - ${addressData.zipCode}`;

	return formatCompleteAddress(completeAddress);
};

function formatCompleteAddress(text: string): string {
	if (!text) return '';

	const separateAddress = text
		.toLowerCase()
		.split('-')
		.map(item => item.trim())
		.filter(item => item);

	const capitalizedAddress = separateAddress.map((value, index) => {
		const {city, uf} = getCityAndUfByRegex(text);

		if (separateAddress[index] === `${city.trim().toLowerCase()}/${uf.trim().toLowerCase()}`) {
			return `${formatText(city)}/${uf.toUpperCase()}`;
		}
		return formatText(value);
	});

	return capitalizedAddress.join(' - ');
}

export {formatAddress, formatCompleteAddress};
